module.exports = __webpack_public_path__ + "img/combats.7b492556.png";